import { usePublicIsLogged, usePublicSignOut } from '@/hooks/usePoleasPublic'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from './AuthContext'

export const PoleasPublicAuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isLoading, error } = usePublicIsLogged()
  const { mutateAsync: logoutAsync, isLoading: isLoggingOut } = usePublicSignOut()

  const navigate = useNavigate()
  const logout = useCallback(async () => {
    await logoutAsync()
    navigate('/poleas/logout')
  }, [logoutAsync, navigate])

  useEffect(() => {
    if (error && !isIn(error?.code, 'ERR_NETWORK', 'ECONNABORTED', 'ERR_CANCELED'))
      logout()
  }, [error, logout])
  
  return (

    <AuthContext.Provider value={{
      isLoading,
      user: user ?? null,
      setReadMessage: () => { },
      logout,
      isLoggingOut
    }}>
      {children}
    </AuthContext.Provider>
  )
}